import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import {
  ButtonComponent,
  CcsInputComponent,
  DashboardAlertComponent,
} from '@shared/components';
import { CourtFileNumbersResponse } from '@shared/interfaces';
import { CourtFileNumberApiService } from '@shared/services';
import { map, tap } from 'rxjs';

@Component({
  selector: 'app-courtfile-create-modal',
  templateUrl: 'courtfile-create-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    CcsInputComponent,
    ButtonComponent,
    MatDialogModule,
    DashboardAlertComponent,
  ],
})
export class CourtFileCreateModalComponent implements OnInit {
  private readonly _fb = inject(FormBuilder);
  private readonly _courtFileNumberApiService = inject(
    CourtFileNumberApiService,
  );

  private readonly _fileNumbersResponse =
    signal<CourtFileNumbersResponse | null>(null);

  protected form = this._fb.group({
    fileNumber: this._fb.control<string | null>(
      {
        value: null,
        disabled: true,
      },
      [Validators.required],
    ),
  });

  protected isLocked = toSignal(
    this.form.controls.fileNumber.statusChanges.pipe(
      map((status) => status === 'DISABLED'),
    ),
    {
      initialValue: this.form.controls.fileNumber.disabled,
    },
  );

  protected nextNumberToUse = computed(() => {
    return this._fileNumbersResponse()?.nextNumber;
  });

  ngOnInit() {
    this._courtFileNumberApiService
      .getCourtFileNumbers()
      .pipe(
        tap((response) => {
          this._fileNumbersResponse.set(response);
          this.form.controls.fileNumber.setValue(response.nextNumber);
        }),
      )
      .subscribe();
  }

  protected unlockInput() {
    this.form.controls.fileNumber.enable();
  }
}
